<div class="container-fluid p-0">

    <!-- Collapsible content -->
    <links>
  
      <!-- Links -->
      <div class="container">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item ">
            <a id="service" routerLink="" class="nav-link waves-light" mdbWavesEffect>
              HOME
            </a>
          </li>
  
        </ul>
      </div>
      <!-- Links -->
    </links>

    <div style="text-align: center;">
        <h2>Page Not Found</h2>
    </div>
</div>
